export enum Path {
    ROOT = '',
    OAUTH = 'oauth',
    CODE = 'code',
    IIN = 'iin',
    BIN = 'bin',
    LIVENESS = 'liveness',
    LIVENESS_QR = 'liveness-qr',
    LIVENESS_QR_SUCCEEDED = 'liveness-qr-succeeded',
    QR_WARNING = 'qr-warning',
    ESIGN_REVOCATION = 'esign-revocation',
    ESIGN_RESETTING = 'esign-resetting',
    OAUTH_AUTHORIZE = 'oauth/authorize',
    OAUTH_CONSENT = 'oauth/consent',
    ERROR_REDIRECT = 'error-redirect',
    ERROR = 'error',
    DOCUMENT = 'document',
    NOT_FOUND = 'not-found',
    AUTH_MATRIX_STATUS = 'auth-matrix-status',
    AUTH_FINISH = 'auth-finish',
}
